import React from 'react';

function XrayForm() {
  return (
    <div>
      <h2>XrayForm</h2>
    </div>
  );
}

export default XrayForm;
